import React, {useRef} from 'react'
import { Loader, ErrorPage } from 'components/UI'
import {mapData} from "helpers";
import useFetchService from "hooks/FetchService";
import SipView from "containers/SipView";

const SipCallRender = () => {
    const {link,statistic,updateData} = useFetchService();
    const rAudioEl = useRef(null);
    const lAudioEl = useRef(null);

    return (
        <>
            {link.state === 'success' &&
            <SipView
                updateData={updateData}
                linkData={mapData(link)}
                statistic={statistic}
                audio={{remote: rAudioEl, local: lAudioEl}}
            />
            }
            {link.state === 'loading' && <Loader/>}
            {link.state === 'error' && <ErrorPage message={link.message}/>}

            <audio ref={rAudioEl} id="remoteAudio"></audio>
            <audio ref={lAudioEl} id="localAudio"></audio>
        </>
    )
}
export default SipCallRender
